import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as actions from "MODULES/session/actions";

export function Logout({ logout }) {
  return (
    <a onClick={logout} type="button" role="button">
      <i className="fa fa-fw fa-btn fa-sign-out" />
      Logout
    </a>
  );
}

Logout.propTypes = {
  logout: PropTypes.func.isRequired
};

export default connect(undefined, actions)(Logout);



// WEBPACK FOOTER //
// ./app/modules/session/components/Logout/Logout.jsx